// Approved Focus dissolve: foreground only, with no translation or scale.
export const FOCUS_DISSOLVE = Object.freeze({ exit: 220, enter: 420, blur: 5 });
export const focusFrames = (phase, from = {}) => phase === 'exit'
  ? [{ opacity: from.opacity ?? 1, filter: from.filter ?? 'blur(0px)' }, { opacity: 0, filter: 'blur(5px)' }]
  : [{ opacity: 0, filter: 'blur(5px)' }, { opacity: 1, filter: 'blur(0px)' }];
export const focusOptions = (phase, reduced = false) => ({
  duration: reduced ? 0 : FOCUS_DISSOLVE[phase],
  easing: phase === 'exit' ? 'ease-in' : 'cubic-bezier(.2,.65,.25,1)',
  ...(phase === 'exit' ? { fill: 'forwards' } : {}),
});

// Navigation must never depend indefinitely on a browser animation timeline
// (WebKit can suspend it while a tab or window is inactive).
export function finishFocus(animation) {
  if (!animation) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const duration = Number(animation.effect?.getTiming?.().duration) || 420;
    const timer = setTimeout(resolve, duration + 120);
    animation.finished.then(() => { clearTimeout(timer); resolve(); }, error => { clearTimeout(timer); reject(error); });
  });
}
